import { render, staticRenderFns } from "./forgot-pw.html?vue&type=template&id=593b3099&scoped=true&external"
import script from "./forgot-pw.js?vue&type=script&lang=js&external"
export * from "./forgot-pw.js?vue&type=script&lang=js&external"
import style0 from "./forgot-pw.scss?vue&type=style&index=0&id=593b3099&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593b3099",
  null
  
)

export default component.exports